export interface AppResp<T> {
  code: AppRespCode
  msg: string
  data?: T
}

export enum AppRespCode {
  CodeSuccess = 0,
  CodeInvalidParameter = 2,
  CodeInternalError = 3,
  CodeGenerating = 4,
  CodeNotEnoughMembershipRights = 5,
  CodeNotEnoughGemsAmount = 6,
  CodeNotEnoughThreeLeafClover = 16,
}
